import moment from "moment";
import "moment/locale/fr";
import i18n from "../i18n";

export const getDateLocale = () =>
  i18n.resolvedLanguage?.startsWith("en") ? "en-GB" : "fr-FR";

const getMomentLocale = () =>
  i18n.resolvedLanguage?.startsWith("en") ? "en" : "fr";

const pad2 = (value) => String(value).padStart(2, "0");

export const formatFrenchDateInput = (dateValue) => {
  if (!dateValue) return "";
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
};

export const formatFrenchTimeInput = (dateValue) => {
  if (!dateValue) return "";
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

export const parseFrenchDate = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || "");
  if (!match) return null;

  const [, dayValue, monthValue, yearValue] = match;
  const day = Number(dayValue);
  const month = Number(monthValue);
  const year = Number(yearValue);
  if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

export const combineFrenchDateAndTime = (dateValue, timeValue) => {
  const date = parseFrenchDate(dateValue);
  const timeMatch = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(timeValue || "");
  if (!date || !timeMatch) return null;

  date.setHours(Number(timeMatch[1]), Number(timeMatch[2]), 0, 0);
  return date;
};

export const simpleDate = (date) => {
  const today = new Date(date);
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  return `${year}-${month}-${day}`;

  // Outputs: "28-11-2024"
};

export const interventionDate = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString(getDateLocale(), {month: "short"});
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return i18n.resolvedLanguage?.startsWith("en")
      ? `Today at ${hour}:${minute}`
      : `Aujourd'hui à ${hour}:${minute}`;
  }
  return i18n.resolvedLanguage?.startsWith("en")
    ? `${day} ${month} at ${hour}:${minute}`
    : `${day} ${month} à ${hour}:${minute}`;

  // Outputs: "28-11-2024"
};

export const proposalDate = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString(getDateLocale(), {month: "long"});
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return i18n.resolvedLanguage?.startsWith("en")
      ? `Today at ${hour}:${minute}`
      : `Aujourd'hui à ${hour}:${minute}`;
  }
  return i18n.resolvedLanguage?.startsWith("en")
    ? `${day} ${month} ${year} at ${hour}:${minute}`
    : `${day} ${month} ${year} à ${hour}h${minute}`;

  // Outputs: "28-11-2024"
};

export const DateGroupedIntervention = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString(getDateLocale(), {month: "long"});
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return i18n.resolvedLanguage?.startsWith("en") ? "Today " : "Aujourd'hui ";
  }
  return `${day} ${month} ${year} `;
};

export function formatDate(date, format) {
  if (!date) {
    return "";
  }
  if (format) {
    return moment(date).locale(getMomentLocale()).format(format);
  }
  return moment(date).locale(getMomentLocale()).format("L, LT");
}
